module.exports = __webpack_public_path__ + "static/media/topographicGrid-02.ddf2ce67.jpg";